<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="consignmentshipment_keyno" [ttModel]="edit.consignmentshipment_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="consignmentshipment_name" [(ttModel)]="edit.consignmentshipment_name" ttRequired></tt-input>
        <tt-checkbox ttLabel="isplanned" [(ttModel)]="edit.isplanned"></tt-checkbox>

        <div [hidden]="edit.isplanned !== '1'">
            <tt-textarea ttLabel="agreement_note" [(ttModel)]="edit.agreement_note"></tt-textarea>
            <tt-datetime ttLabel="planned_shipping_dt" [(ttModel)]="edit.planned_shipping_dt"></tt-datetime>
        </div>

        <tt-checkbox ttLabel="isshipped" [(ttModel)]="edit.isshipped"></tt-checkbox>

        <div [hidden]="edit.isshipped !== '1'">
            <tt-datetime ttLabel="actual_shipping_dt" [(ttModel)]="edit.actual_shipping_dt"></tt-datetime>
            <tt-datetime ttLabel="estimated_arrival_dt" [(ttModel)]="edit.estimated_arrival_dt"></tt-datetime>
            <tt-input ttLabel="shipped_by_portal_user_name" [ttModel]="edit.shipped_by_portal_user_name" ttReadonly></tt-input>
        </div>

        <tt-input ttLabel="stockplace_name" [ttModel]="edit.stockplace_name" ttReadonly></tt-input>
        <tt-input ttLabel="reg_by_portal_user_name" [ttModel]="edit.reg_by_portal_user_name" ttReadonly></tt-input>
        <tt-datetime ttLabel="reg_datetime" [(ttModel)]="edit.reg_datetime"></tt-datetime>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="consignmentShipmentKeyno !== '0'" ttText="delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
        <tt-button-settings *ngIf="edit.show_setting === '1'"></tt-button-settings>
    </tt-card>
</tt-page>
